module.exports = __webpack_public_path__ + "static/img/leak_red_anim.f4d285d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/leak_red_anim.gif
// module id = 718
// module chunks = 6